declare var mapboxgl: any;
declare var document: any;
declare var MapboxGeocoder: any;
import {Component, Vue} from 'vue-property-decorator';
import VueGoogleAutocomplete from 'vue-google-autocomplete';
import StepperFlow from '@/services/StepperFlow';
import RoundedButton from '@/components/RoundedButton/RoundedButton.vue';
import {radiusOptions} from '@/constants/config';
import Logger from '@/services/Logger';

@Component({
  components: {VueGoogleAutocomplete, RoundedButton},
})
export default class Location extends Vue {
  public state = StepperFlow;
  public showInvalidLocationField = false;
  public moneySign = location.href.search("geo=gb") > -1 || location.href.search("geo=uk") > -1 ? "£" : "$";

  public radiusItems = radiusOptions
    .map((value) => ({value, text: `${value} Miles`}));

  public mounted() {
    var self = this;
    if (StepperFlow.location) {
      //(this.$refs.location as any).update(StepperFlow.location.formattedLocation);

      mapboxgl.accessToken = 'pk.eyJ1IjoiZWxpZG9yIiwiYSI6ImNqbGF1MmJvdDFsZTEzcXMybHU1aHZub2MifQ.RJoCQ30JAUez2t4RyfuJaw';

      var geo = self.$route.query.geo;

      if (geo == "uk") {
        geo = "gb"
      }

      //locality
      var geocoder = new MapboxGeocoder({
        flyTo: false,
        placeholder: "Type your location",
        types: "place",
        country: geo,
        accessToken: mapboxgl.accessToken
      });

      geocoder.on("result", function (place, s) {

        //console.log("s", s)
        //console.log("place", place)

        var location = {
          latitude: null,
          longitude: null
        };


        if (place && place.result && place.result.place_name) {
          StepperFlow.location.formattedLocation = place.result.place_name;
        }

        if (place && place.result && place.result.geometry && place.result.geometry.coordinates) {


          //debugger
          console.log("self.coordinates", place.result.geometry);
          console.log("self.$route", self.$route);
          location.latitude = place.result.geometry.coordinates[1];
          location.longitude = place.result.geometry.coordinates[0];

          try {
            localStorage.setItem("formattedLocation", place.result.place_name);
          } catch (e) {

          }

          StepperFlow.location = location;

          StepperFlow.saveLocationState();
          self.$router.push({path: '/keywords', query: self.$route.query});

        }
      });

      try {
        document.getElementById('location-container').appendChild(geocoder.onAdd());
      } catch (e) {

      }


    }
  }

  public handleLocationChanged(location: object) {
    Logger.logLocationChange(location);
    StepperFlow.location = location;
  }

  public handleInputChange({newVal}: { newVal: string }) {
    if (newVal) {
      StepperFlow.location.formattedLocation = newVal;
    }
  }

  public onErrorCloseClick() {


    var inputElement = document.getElementById("map");
    if (inputElement) {
      inputElement.focus();
    }


    console.log("this.$refs.location ", this.$refs.location);
  }

  public handleRadiusChange(value: number) {
    Logger.logRadiusChange(value);
  }

  public submitLocations() {
    if (!StepperFlow.location.latitude) {
      //this.showInvalidLocationField = true;
      //return;
    }

    this.$router.push({path: '/keywords', query: this.$route.query});
  }
}
